import type { PaymentType } from 'models/api';
import {
	isPaymentTypeWithComponentState,
	type PaymentComponentState,
} from 'utils/business-logic';

export function isPaymentReadyForCheckout(
	paymentType: PaymentType | undefined,
	paymentComponentState: PaymentComponentState | undefined,
): boolean {
	// Fully paying with a coupon can mean there is no payment type. Ensuring
	// selection of a payment type is handled by backend.
	if (!paymentType || !isPaymentTypeWithComponentState(paymentType)) {
		return true;
	}
	return Boolean(paymentComponentState?.isValid);
}
